import React, { useEffect, useRef, useState } from "react";
import { Avatar } from "@mui/material";
import lecturaResumenService from "../../../../services/libroResumidoService";

const portadaUrlCache = new Map();

const PortadaAvatar = ({ resumenId, sx, ...props }) => {
  const [src, setSrc] = useState(portadaUrlCache.get(resumenId) || "");
  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;

    const run = async () => {
      if (!resumenId) return;

      const cached = portadaUrlCache.get(resumenId);
      if (cached) {
        setSrc(cached);
        return;
      }

      try {
        const blob = await lecturaResumenService.descargarImagen(resumenId);
        if (!aliveRef.current) return;

        const url = URL.createObjectURL(blob);
        portadaUrlCache.set(resumenId, url);
        setSrc(url);
      } catch (e) {
        if (!aliveRef.current) return;
        setSrc("");
      }
    };

    run();

    return () => {
      aliveRef.current = false;
    };
  }, [resumenId]);

  return (
    <Avatar
      variant="rounded"
      src={src}
      sx={sx}
      {...props}
    />
  );
};

export default PortadaAvatar;
